import { createReducer } from 'redux-act';

import {
  FETCH_SESSIONS_INIT,
  FETCH_SESSIONS_SUCCESS,
  FETCH_SESSIONS_FAIL,
  FETCH_SESSION_DETAILS_INIT,
  FETCH_SESSION_DETAILS_SUCCESS,
  FETCH_SESSION_DETAILS_FAIL,
  FETCH_SESSIONS_LIST_INIT,
  FETCH_SESSIONS_LIST_SUCCESS,
  FETCH_SESSIONS_LIST_FAIL,
  CLEAR_SESSIONS_DATA,
  EXPORT_SESSIONS_INIT,
  EXPORT_SESSIONS_SUCCESS,
  EXPORT_SESSIONS_FAIL,
} from '../../actions/session';

const initialState = {
  loading: false,
  error: null,
  fetched: false,
  pagedList: [],
  list: [],
  currentSession: {},
  analytics: {
    totalSessions: 0,
    avgDuration: 0,
    avgQuestions: 0,
    unansweredRate: 0,
    hourlyDistribution: [],
    sessionsByDayOfWeek: [],
    languageDistribution: [],
    topPOIs: [],
    topEvents: [],
    sitePerformance: [],
    siteGrowth: [],
  },
  message: '',
  exporting: false,
  exportError: null,
};

/**
 * Reducer for handling session data state using redux-act.
 */
const sessionReducer = createReducer(
  {
    [FETCH_SESSIONS_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),

    [FETCH_SESSIONS_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      fetched: true,
      list: payload.list || [],
      analytics: payload.analytics || state.analytics,
      message: payload.message || state.message,
    }),

    [FETCH_SESSIONS_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      fetched: true,
      error: payload.error,
      list: [],
      analytics: initialState.analytics, // Reset analytics on error
    }),

    [FETCH_SESSION_DETAILS_INIT]: (state) => ({
      ...state,
      loading: true,
      currentSession: null,
      error: null,
    }),
    [FETCH_SESSION_DETAILS_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      currentSession: payload.session,
    }),
    [FETCH_SESSION_DETAILS_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
      currentSession: null,
    }),

    [FETCH_SESSIONS_LIST_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [FETCH_SESSIONS_LIST_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      pagedList: payload,
    }),
    [FETCH_SESSIONS_LIST_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
      pagedList: initialState.pagedList,
    }),

    [EXPORT_SESSIONS_INIT]: (state) => ({
      ...state,
      exporting: true,
      exportError: null,
    }),

    [EXPORT_SESSIONS_SUCCESS]: (state) => ({
      ...state,
      exporting: false,
    }),

    [EXPORT_SESSIONS_FAIL]: (state, payload) => ({
      ...state,
      exporting: false,
      exportError: payload.error,
    }),

    [CLEAR_SESSIONS_DATA]: () => initialState,
  },
  initialState
);

export default sessionReducer;
